
import { useState } from 'react';
import { likeTechnique, unlikeTechnique } from '@/services';

export const useTechniqueLikes = (
  techniqueId: string, 
  showLikeUI: boolean = true, 
  initialIsLiked: boolean = false,
  initialLikeCount: number = 0
) => {
  const [isLiked, setIsLiked] = useState<boolean>(initialIsLiked);
  const [likeCount, setLikeCount] = useState<number>(initialLikeCount);
  const [isLiking, setIsLiking] = useState<boolean>(false);
  const [likeAnimation, setLikeAnimation] = useState<boolean>(false);

  const handleLikeToggle = async (
    e: React.MouseEvent, 
    customLikeToggleHandler?: (e: React.MouseEvent) => void
  ) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    // If a custom handler is provided, call it and return
    if (customLikeToggleHandler) {
      customLikeToggleHandler(e);
      return;
    }
    
    // Only allow liking if showLikeUI is true
    if (!showLikeUI) return;
    
    // Skip if already processing
    if (isLiking) return;
    
    setIsLiking(true);
    
    try {
      if (isLiked) {
        await unlikeTechnique(techniqueId);
        setIsLiked(false);
        setLikeCount((prev: number) => Math.max(0, prev - 1));
      } else {
        await likeTechnique(techniqueId);
        setIsLiked(true);
        setLikeCount((prev: number) => prev + 1);
        setLikeAnimation(true);
        setTimeout(() => setLikeAnimation(false), 1000);
      }
    } catch (error) {
      console.error('Error toggling like:', error);
    } finally {
      setIsLiking(false);
    }
  };

  return {
    isLiked,
    isLiking,
    likeCount,
    likeAnimation,
    handleLikeToggle
  };
};
